import React from 'react';

const GetMoreOrdersIcon: React.FC<{ className?: string }> = ({ className }) => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width="120" 
      height="120" 
      viewBox="0 0 120 120" 
      fill="none"
      className={className}
    >
      <path d="M94.96 109.003V38.4129H109.003L85.483 9.99993L61.96 38.4129H76.003V109.003H94.96Z" fill="white"/>
      <path d="M94.96 109.003V38.4129H109.003L85.483 9.99993L61.96 38.4129H76.003V109.003H94.96Z" stroke="white" strokeWidth="3.063" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M94.96 109.003V38.4129H109.003L85.483 9.99993L61.96 38.4129H76.003V109.003H61.96V58.3779H43.003V109.003H28.957V78.3459H10V109.003" stroke="#762D50" strokeWidth="3.063" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
};

export default GetMoreOrdersIcon;
